/*
 * "Phone messages – no caller ID" (api phone_match.py, 10-20).
 *
 * The phone-message service files a message under the practice's own number
 * when it can't tell who called (the main line forwards with our number as
 * caller ID). That conversation has nobody to reply to: the gateway refuses
 * a reply / SMS to a practice number with 400 { reason: "no_caller_id_thread" }.
 * Both chat copies (header/chat, fax/chat) show a banner there, disable send,
 * and turn that 400 into an inline error that keeps the typed text.
 */

export const NO_CALLER_THREAD_NAME = "Phone messages – no caller ID";
export const NO_CALLER_REASON = "no_caller_id_thread";
export const NO_CALLER_REPLY_ERROR =
  "Can't reply – this message came in without a caller number. Use the callback number in the message.";
export const NO_CALLER_BANNER =
  "Replies are disabled here – these phone messages came in without a caller number. Use the callback number in each message.";

// The conversation the service files caller-less messages under (name set by
// the gateway; older rows were renamed by the re-file script).
export function isNoCallerThread(patient) {
  return (patient?.patientname || "").trim() === NO_CALLER_THREAD_NAME;
}

// An axios error (or an already-unwrapped body) for a refused reply.
export function isNoCallerReplyError(error) {
  const body = error?.response?.data ?? error;
  return error?.response?.status === 400 && body?.reason === NO_CALLER_REASON;
}
